import { FC, useState } from 'react';
import { hooks } from '../hooks';
import { custom } from '../custom';
import { svg } from '../assets/svg';
import { theme } from '../constants';
import { components } from '../components';
import { useAppDispatch, store } from '../store';
import { registerHandler } from '../services/registerHandler';
import { toast } from 'react-toastify';

const renderHeader = (): JSX.Element => {
  return <components.Header goBack={true} />;
};

export const SignUp: FC = (): JSX.Element => {
  const navigate = hooks.useAppNavigate();
  const dispatch = useAppDispatch();
  const [formData, setFormData] = useState({
    username: '',
    phone_number: '',
    first_name: '',
    last_name: '',
    address: '',
    city: '',
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [fieldErrors, setFieldErrors] = useState<Record<string, string>>({}); // 💡 برای ارورهای فیلدی

  const handleChange = (field: string, value: string) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
    setFieldErrors((prev) => ({
      ...prev,
      [field]: '', // پاک کردن ارور هنگام تایپ
    }));
  };

  const validateForm = () => {
    if (!formData.username || !formData.phone_number || !formData.first_name || !formData.last_name) {
      toast.error('لطفاً تمام فیلدهای ضروری را پر کنید.');
      setError('لطفاً تمام فیلدهای ضروری را پر کنید.');
      return false;
    }
    return true;
  };

  const handleRegister = async () => {
    if (loading) return;
    setError(null);
    setFieldErrors({});

    if (!validateForm()) return;

    setLoading(true);

    try {
      const result = await registerHandler(
        {
          ...formData,
        },
        dispatch,
        store.getState
      );

      if (result.success) {
        navigate('/login');
      } else {
        setError(result.message || 'خطایی رخ داد.');
        if (result.fieldErrors) {
          setFieldErrors(result.fieldErrors); // ⬅️ ذخیره ارورهای فیلدی
        }
      }
    } catch (e) {
      setError('در ارتباط با سرور مشکلی پیش آمد.');
    } finally {
      setLoading(false);
    }
  };

  const renderContent = (): JSX.Element => {
    return (
      <div style={{ padding: '50px 20px 20px 20px' }}>
        <h1
          style={{
            margin: 0,
            textAlign: 'center',
            ...theme.fonts.Mulish_700Bold,
            color: theme.colors.mainColor,
            fontSize: 32,
            lineHeight: 1.2,
            textTransform: 'capitalize',
            marginBottom: 40,
          }}
        >
          عضویت
        </h1>

        {error && (
          <p style={{ color: 'red', textAlign: 'center', marginBottom: 20 }}>
            {error}
          </p>
        )}

        <custom.InputField
          label="نام کاربری"
          placeholder="user"
          icon={<svg.InputCheckSvg />}
          value={formData.username}
          onChange={(value) => handleChange('username', value)}
          error={fieldErrors.username}
          containerStyle={{ marginBottom: 20 }}
        />

        <custom.InputField
          label="شماره موبایل"
          placeholder="09121234567"
          icon={<svg.InputCheckSvg />}
          value={formData.phone_number}
          onChange={(value) => handleChange('phone_number', value)}
          error={fieldErrors.phone_number}
          containerStyle={{ marginBottom: 20 }}
        />

        <custom.InputField
          label="نام"
          placeholder="نام"
          icon={<svg.InputCheckSvg />}
          value={formData.first_name}
          onChange={(value) => handleChange('first_name', value)}
          error={fieldErrors.first_name}
          containerStyle={{ marginBottom: 20 }}
        />
        <custom.InputField
          label="نام خانوادگی"
          placeholder="نام خانوادگی"
          icon={<svg.InputCheckSvg />}
          value={formData.last_name}
          onChange={(value) => handleChange('last_name', value)}
          error={fieldErrors.last_name}
          containerStyle={{ marginBottom: 20 }}
        />
        <custom.InputField
          label="آدرس"
          placeholder="مازندران - آمل"
          icon={<svg.InputCheckSvg />}
          value={formData.address}
          onChange={(value) => handleChange('address', value)}
          error={fieldErrors.address}
          containerStyle={{ marginBottom: 20 }}
        />

        <custom.InputField
          label="شهر"
          placeholder="آمل"
          icon={<svg.InputCheckSvg />}
          value={formData.city}
          onChange={(value) => handleChange('city', value)}
          error={fieldErrors.city}
          containerStyle={{ marginBottom: 20 }}
        />

        <components.Button
          title={loading ? 'در حال ارسال...' : 'عضویت'}
          onClick={handleRegister}
          style={{ marginBottom: 20 }}
          disabled={loading}
        />

        <div
          style={{
            flexDirection: 'row',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <span
            style={{
              marginLeft: 4,
              ...theme.fonts.Mulish_400Regular,
              color: theme.colors.textColor,
              fontSize: 16,
              lineHeight: 1.7,
            }}
          >
            قبلاً حساب کاربری ساخته‌اید؟
          </span>
          <span
            style={{
              ...theme.fonts.Mulish_400Regular,
              color: theme.colors.mainColor,
              fontSize: 16,
              lineHeight: 1.7,
              cursor: 'pointer',
            }}
            onClick={() => {
              navigate('/');
            }}
          >
            وارد شوید.
          </span>
        </div>
      </div>
    );
  };

  return (
    <>
      {renderHeader()}
      {renderContent()}
    </>
  );
};
